import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initGtag } from './lib/gtag'
import { initTracking } from '@mtrx/cms-client'

initGtag()

// MTRX cookieless pageview beacon → portal Stats tab (prod only).
if (import.meta.env.PROD) initTracking({ slug: 'fateh-hvac' })

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
